<template>
  <div class="popup form-popup visible" id="event-booking-popup">
    <div class="popup-box">

      <p class="h2 title line">Add New LX EVENT</p>
      <form action="#" class="form">
        <div class="field" :class="v$.terminalId.$error ? 'error-field' : ''">
          <label class="field-name">LX Terminal</label>
          <Select2 v-model="terminalId" :options="terminals" :placeholder="'Select LX Terminal'"  @change="myChangeEvent($event)" @select="mySelectEvent($event)" name="select" class="select select-search" data-placeholder="Select LX Terminal" />
          <span class="error-text" v-if="v$.terminalId.$error">You must select LX Terminal.</span>
        </div>
        <div class="field-wrap">
          <div class="field start-date" :class="v$.startDate.$error ? 'error-field' : ''">
            <label class="field-name">Start date</label>
            <date-time-picker class="form-control datepicker" v-model="startDate" :options="dateOptions" placeholder="Start date" @update="checkDates"/>
            <span class="error-text" v-if="v$.startDate.$error">You must fill Start date.</span>
          </div>
          <div class="field finish-date" :class="v$.finishDate.$error ? 'error-field' : ''">
            <label class="field-name">Finish date</label>
            <date-time-picker class="form-control datepicker" v-model="finishDate" :options="dateOptions" placeholder="Finish date" @update="checkDates"/>
            <span class="error-text" v-if="v$.finishDate.$error">You must fill Finish date.</span>
          </div>
        </div>

        <div class="field-wrap">
          <div class="field start-time" :class="v$.startTime.$error ? 'error-field' : ''">
            <label class="field-name">Start time</label>
            <date-time-picker class="form-control timepicker" v-model="startTime" :options="timeOptions" @update="checkDates"
                              placeholder="Start time"/>
            <span class="error-text" v-if="v$.startTime.$error">You must fill Start time.</span>
          </div>
          <div class="field finish-time" :class="v$.finishTime.$error ? 'error-field' : ''">
            <label class="field-name">Finish time</label>
            <date-time-picker class="form-control timepicker" v-model="finishTime" :options="timeOptions" @update="checkDates"
                              placeholder="Finish time"/>

            <span class="error-text" v-if="v$.finishTime.$error">You must fill Finish time.</span>
          </div>
        </div>

        <div class="field location" :class="v$.location.$error ? 'error-field' : ''">
          <div class="field-name-wrap">
            <label class="field-name">Location</label>
            <a href="" class="locate" @click.prevent="locateMeClick">Locate me</a>
          </div>
          <Select2 v-model="location" :options="locations" :placeholder="'Select Location'"  @change="myChangeEvent($event)" @select="mySelectEvent($event)" name="select" class="select select-search" data-placeholder="Select LX Terminal" />
          <span class="error-text" v-if="v$.location.$error">You must select Location</span>
        </div>
        <div class="error-field" v-if="generalMessage">
          <span class="error-text">{{generalMessage}}</span>
        </div>
        <div class="form-btn-box">
          <button class="btn success no-bg small" @click.prevent="closePopup">
            <icon-base width="20" height="21" viewBox="0 0 20 21">
              <icon-deny/>
            </icon-base>
            <span>Cancel</span>
          </button>
          <button type="button" class="btn success small" @click.prevent="addEventClick">
            <icon-base width="25" height="26" viewBox="0 0 26 27">
              <icon-success/>
            </icon-base>
            <span>BOOK</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import {mapMutations, mapActions, mapState} from "vuex"
import Select2 from './MySelect2';
import RequestRegistered from "./RequestRegistered"
import IconBase from "../common/IconBase";
import IconDeny from "../common/icons/IconDeny";
import IconSuccess from "../common/icons/IconSuccess";
import DateTimePicker from "../common/DateTimePicker"

import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
    name: 'add-event',

    setup () {
        return { v$: useVuelidate() }
    },

    validations() {
        return {
            terminalId: {required},
            startDate: {required},
            finishDate: {required},
            finishTime: {required},
            startTime: {required},
            location: {required},
        }
    },

    data () {
        return {
            //picked: picked,
            timeOptions: {
                datepicker: false,
                format: 'H:i',
            },
            dateOptions: {
                timepicker: false,
                format: 'Y-m-d',
                minDate: new Date()
            },


            startDate: null,
            finishDate: null,
            startTime: null,
            finishTime: null,
            terminalId: 0,
            location: '',
            //locations: ['Germany, Berlin', 'Australia, Canberra', 'New Zealand, Wellington'],
            generalMessage: ''
        }
    },
    components: {IconSuccess, IconDeny, IconBase, Select2/*, Datepicker */, DateTimePicker},

    computed: {
        ...mapState('events', [
            'terminals',
            'locations'
        ]),
    },

    created() {
      this.loadTerminals().then(() => {
      });
    },

    methods: {

        ...mapMutations([
            'switchPopup',
            'setPopupComponent',
        ]),
        ...mapActions('events', [
            'addEvent',
            'loadEvents',
            'loadTerminals',
            'getLocation'
        ]),
        closePopup() {
            this.switchPopup(false);
        },
        myChangeEvent(){
        },
        mySelectEvent(){
        },
        checkDates() {
            console.log('check')
            this.generalMessage = '';
            if (new Date(this.startDate + ' ' + this.startTime) >= new Date(this.finishDate + ' ' + this.finishTime)) {
                this.generalMessage = 'Event start date and time cannot be later than the end';
                return false;
            }

            return true;
        },
        addEventClick() {
            this.v$.$touch();
            if (!this.v$.$invalid) {
                if (!this.checkDates()) return false;
                this.addEvent({
                    terminal_id: this.terminalId,
                    start_time: this.startDate + ' ' + this.startTime + ':00',
                    finish_time: this.finishDate + ' ' + this.finishTime + ':00',
                    status: 'active',
                    location: this.location
                }).then(() => {
                    this.loadEvents();
                    this.setPopupComponent(RequestRegistered);
                }).catch(() => {
                })
            }
        },
        locateMeClick() {
          console.log('locate me')
          navigator.geolocation.getCurrentPosition(position => {
            //const { latitude, longitude } = position.coords;
            this.getLocation({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            }).then((address) => {
              if(!this.locations.includes(address)) {
                this.locations.push(address)
              }
              this.location = address
            }).catch(() => {
            })
          });
        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .select2-container {
    width: 500px !important;
  }
  .field.select {
    margin: 0 0 5px;
  }

  /*.popup .error-field::before {
    bottom: 22px;
  }

  .popup .error-field::after{
    bottom: 33px;
  }

  .form-control {
    margin-bottom: 15px;
  }*/
  .field:not(.error-field) .form-control {
    margin-bottom: 15px;
  }
  .popup .error-field::before {
    bottom: 22px;
  }

  .popup .error-field::after{
    bottom: 33px;
  }

  .popup .start-time:not(.error-field)::before, .popup .finish-time:not(.error-field)::before, .popup .start-date:not(.error-field)::before, .popup .finish-date:not(.error-field)::before {
    bottom: 15px;
  }

  .popup .start-date:not(.error-field)::after, .popup .finish-date:not(.error-field)::after, .popup .start-time:not(.error-field)::after, .popup .finish-time:not(.error-field)::after{
    bottom: 25px;
  }




</style>
